import React, { useContext, useState, useMemo } from 'react';
import UserContext from '../../../context/Globales/UserContext'
import { Page, Text, View, Document, Image, PDFDownloadLink } from '@react-pdf/renderer';
import moment from 'moment';
import { makeStyles } from '@material-ui/core';
import spanish from "moment/locale/es";
import { v4 as uuid } from 'uuid';


const useStyle = makeStyles((theme) => ({
    pdf: {
        height: '92vh',
        width: '100%'
    },
    sizeIcono: {
        maxHeight: '38px',
        minWidth: '38px',
        color: theme.palette.fondoiconos.main,
    },
    verificacion: {
        flexGrow: 1,
        flexDirection: 'row'
    },
    alert: {
        backgroundColor: theme.palette.alerta.main
    }
}));

const Informe = () => {

    const classes = useStyle();

    const { DataOnp, DataBanco, DataForm } = useContext(UserContext);



    const busqueda = JSON.parse(localStorage.getItem('busqueda'));

    //console.log(DataLogin);
    //  console.log(DataOnp);

    //const detallesOnp = JSON.parse(localStorage.getItem('detallesOnp'));

    const Folio = DataOnp.Folio;
    const Antecedentes = DataOnp.Antecedentes;
    const Verificacion = DataOnp.Verificacion;
    const Morosidades = DataOnp.Morosidades;
    const RelacionRUT = DataOnp.RelacionRUT;



    const banco = busqueda.banco
    const ctacte = busqueda.ctacte
    const monto = busqueda.monto
    const nrodoc = busqueda.nrodoc
    const serieRUT = busqueda.serieRUT

    let Codigo = banco
    let nombre = '';

    switch (Codigo) {
        case '1':
            nombre = 'BANCO DE CHILE'
            break;

        case '9':
            nombre = 'BANCO INTERNACIONAL'
            break;
        case '12':
            nombre = 'BANCO DEL ESTADO DE CHILE'
            break;
        case '14':
            nombre = 'BANCO SCOTIABANK'
            break;

        case '16':
            nombre = 'BANCO DE CREDITO E INV'
            break;
        case '17':
            nombre = 'BANCO DO BRASIL S.A.'
            break;
        case '27':
            nombre = 'CORPBANCA'
            break;
        case '28':
            nombre = 'BANCO BICE'
            break;
        case '29':
            nombre = 'BANCO DE A.EDWARDS'
            break;
        case '31':
            nombre = 'HSBC BANK(CHILE)'
            break;
        case '33':
            nombre = 'CITIBANK N.A.'
            break;
        case '37':
            nombre = 'BANCO SANTANDER'
            break;
        case '39':
            nombre = 'ITAU (EX BANKBOSTON)'
            break;
        case '41':
            nombre = 'JP MORGAN CHASE BANK, N. A.'
            break;
        case '43':
            nombre = 'BANCO DE LA NACION ARGENTINA'
            break;
        case '45':
            nombre = 'THE BANK OF TOKIO'
            break;
        case '46':
            nombre = 'THE ROYAL BANK OF SCOTLAND (RBS)'
            break;
        case '49':
            nombre = 'BANCO SECURITY'
            break;
        case '51':
            nombre = 'BANCO FALABELLA'
            break;
        case '52':
            nombre = 'DEUTSCHE BANK (CHILE)'
            break;
        case '53':
            nombre = 'BANCO RIPLEY'
            break;
        case '54':
            nombre = 'BANCO HNS'
            break;
        case '55':
            nombre = 'BANCO CONSORCIO'
            break;
        case '56':
            nombre = 'BANCO PENTA'
            break;
        case '57':
            nombre = 'BANCO PARIS'
            break;
        case '59':
            nombre = 'BANCO BTG PACTUAL CHILE'
            break;
        case '60':
            nombre = 'CHINA CONSTRUCTION BANK'
            break;
        case '504':
            nombre = 'BANCO BBVA'
            break;
        case '507':
            nombre = 'BANCO DE DESARROLLO'
            break;
        default:
            break;
    }

    moment.locale('spanish');
    const fecha = moment().format('LLLL'); // FORMATO: Domingo 15 Julio 2012 11:01
    //const fecha = moment().calendar()

    function number_format(amount, decimals) {

        amount += ''; // por si pasan un numero en vez de un string
        amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto

        decimals = decimals || 0; // por si la variable no fue fue pasada

        // si no es un numero o es igual a cero retorno el mismo cero
        if (isNaN(amount) || amount === 0)
            return parseFloat(0).toFixed(decimals);

        // si es mayor o menor que cero retorno el valor formateado como numero
        amount = '' + amount.toFixed(decimals);

        var amount_parts = amount.split('.'),
            regexp = /(\d+)(\d{3})/;

        while (regexp.test(amount_parts[0]))
            amount_parts[0] = amount_parts[0].replace(regexp, '$1' + '.' + '$2');

        return amount_parts.join('.');
    }



    const tableInfoConsulta = (

        <View style={{ width: '95%', margin: '5, 15', flexDirection: 'column', borderRadius: '3', border: '1' }}>
            {/*<Text style={{textAlign: 'center', fontSize: '12', backgroundColor: '#A9D0F5' , border: '0', padding: '3, 5'}} >Informacion Preliminar </Text>*/}

            <>
                <View style={{ justifyContent: 'space-around', flexDirection: 'row', fontSize: 10, border: '0 ', backgroundColor: '#A9D0F5' }}>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '12%', textAlign: 'center' }}>Serie</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '13%', textAlign: 'center' }}>N°Documento</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '17%', textAlign: 'center' }}>Banco</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '15%', textAlign: 'center' }}>Cuenta Corriente</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '10%', textAlign: 'center' }}>Monto</Text>

                </View>

                <View style={{ justifyContent: 'space-around', flexDirection: 'row', fontSize: 10, border: '0 ', backgroundColor: '#eeeeee' }}>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '12%', textAlign: 'center' }}>{serieRUT === '' ? '-----' : serieRUT}</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '13%', textAlign: 'center' }}>{nrodoc}</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '17%', textAlign: 'center' }}>{nombre}</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '15%', textAlign: 'center' }}>{ctacte}</Text>
                    <Text style={{ margin: '1,5', padding: '1, 5', width: '10%', textAlign: 'center' }}>{number_format(monto)}</Text>

                </View>



                {/*        <View style={{flexDirection: 'row', fontSize: 9, border: 1, backgroundColor: '#A9D0F5' }}>
            <Text style={{margin: '1, 5', padding: '1, 5', width: '4%',}}>#</Text>
            <Text style={{margin: '1, 5', padding: '1, 5', width: '22%',}}>Codigo</Text>
            <Text style={{margin: '1, 5', padding: '1, 5', width: '40%',}}>Descripción</Text>
            <Text style={{margin: '1, 5', padding: '1, 5', width: '10%',}}>Cantidad</Text>
            <Text style={{margin: '1, 5', padding: '1, 5', width: '12%', textAlign: 'right'}}>Precio</Text>
            <Text style={{margin: '1, 5', padding: '1, 5', width: '12%', textAlign: 'right'}}>Total</Text>
</View>*/}
            </>

        </View>

    );



    const table = (

        <View style={{ width: '95%', margin: '5, 15', flexDirection: 'column', borderRadius: '3', border: '1' }}>
            <Text style={{ textAlign: 'center', fontSize: '12', backgroundColor: '#A9D0F5', border: '0', padding: '3, 5' }} >Antecedentes </Text>
            {Antecedentes.map((item, id) => (
                <>


                    <View style={{ justifyContent: 'space-around', flexDirection: 'row', border: '0 ', backgroundColor: '#eeeeee' }} key={id + 1}>
                        <Text style={{ margin: '1,5', padding: '5, 5', width: '50%', textAlign: 'justify', fontSize: 10 }}>{item.Concepto}</Text>
                        <Text style={{ margin: '1,5', padding: '5, 5', width: '50%', textAlign: 'justify', fontSize: 10 }}> {item.Valor} </Text>


                    </View>
                </>
            ))}
        </View>

    );

    const tableAntecedentes = (

        <View style={{ margin: '5, 40' }} >
            <Text style={{ textAlign: 'center', fontSize: '12' }} >Antecedentes </Text>
            {Antecedentes.map((item) => (
                <View style={{ justifyContent: 'space-between', flexDirection: 'row', width: '100%', backgroundColor: '#eeeeee' }} >

                    <View style={{ fontSize: 13 }} >
                        <Text >{item.Concepto}: </Text>

                    </View>
                    <View style={{ fontSize: 13 }} >
                        <Text >{item.Valor}</Text>

                    </View>
                </View>
            ))}
        </View>

    );

    const tableVerificacion = (
        <>

            {Verificacion.map((item, i) => (
                <>
                    {Verificacion.length === 5 ? (

                        <View style={{ justifyContent: 'space-around', width: '100%', margin: '8, 20', marginRight: '1', flexDirection: 'column', borderRadius: '2', border: '1' }} >

                            <Text style={{ textAlign: 'center', backgroundColor: '#A9D0F5', padding: '5px' }} >{item.Concepto == 'Fecha ONP' ? 'Fecha Orden de no Pago' : item.Concepto == 'Motivo' ? <> Motivo Orden de no Pago </> : item.Concepto} </Text>
                            <Text style={{ flexDirection: 'column', textAlign: 'center', backgroundColor: '#eeeeee', padding: '5px' }}>{item.Valor == '' ? 'NO EXISTEN DATOS' : item.Valor}</Text>

                        </View>
                    ) : Verificacion.length === 4 ? (

                        <View style={{ justifyContent: 'space-around', width: '100%', margin: '5, 43', marginRight: '1', flexDirection: 'column', borderRadius: '2', border: '1' }}  >

                            <Text style={{ textAlign: 'center', backgroundColor: '#A9D0F5', padding: '5px' }} >{item.Concepto == 'Fecha ONP' ? 'Fecha Orden de no Pago' : item.Concepto == 'Motivo' ? <> Motivo Orden de no Pago </> : item.Concepto} </Text>
                            <Text style={{ flexDirection: 'column', textAlign: 'center', backgroundColor: '#eeeeee', padding: '5px' }}>{item.Valor == '' ? 'NO EXISTEN DATOS' : item.Valor}</Text>

                        </View>

                    ) : (

                        <View style={{ justifyContent: 'space-around', width: '95%', margin: '8, 7', marginRight: '1', borderRadius: '2', border: '1', flexDirection: 'column', backgroundColor: '#A9D0F5' }}>

                            <Text style={{ textAlign: 'center', backgroundColor: '#A9D0F5', padding: '5px' }} >{item.Concepto == 'Fecha ONP' ? 'Fecha Orden de no Pago' : item.Concepto == 'Motivo' ? <>  Motivo Orden de no Pago </> : item.Concepto} </Text>
                            <Text style={{ flexDirection: 'column', textAlign: 'center', backgroundColor: '#eeeeee', padding: '5px' }}>{item.Valor == '' ? 'NO EXISTEN DATOS' : item.Valor}</Text>

                        </View>

                    )}
                </>
            ))}
        </>
    );

    const tableMorosidades = (

        <View style={{ width: '95%', margin: '5, 15', flexDirection: 'column', borderRadius: '3', border: '1' }}>
            <Text style={{ textAlign: 'center', fontSize: '12', backgroundColor: '#A9D0F5', border: '0', padding: '3, 5' }} >Morosidades </Text>
            {Morosidades.map((item) => (
                <>

                    <View style={{ justifyContent: 'space-between', flexDirection: 'row', border: '0 ', backgroundColor: '#eeeeee' }}>

                        <Text style={{ flexDirection: 'column', margin: '1, 5', padding: '5, 5', fontSize: 10 }}> {item.Concepto}</Text>
                        <Text style={{ flexDirection: 'row', margin: '1, 5', padding: '5, 5', fontSize: 10 }} >  {number_format(item.Valor)}</Text>
                        {/*className={ item.Valor > 0 && classes.alert}  no pesca, averiguar esto como hacerlo*/}

                    </View>

                </>
            ))}

        </View>

    );

    const tableRelacionRut = (

        <View style={{ width: '95%', margin: '5, 15', flexDirection: 'column', borderRadius: '3', border: '1' }}>
            <Text style={{ textAlign: 'center', fontSize: '12', backgroundColor: '#A9D0F5', padding: '3, 5' }} >Relacion Cta / Rut </Text>
            {RelacionRUT.map((item) => (
                <>

                    <View style={{ justifyContent: 'space-around', flexDirection: 'row', border: '0 ', backgroundColor: '#eeeeee' }}>
                        <Text style={{ margin: '1,5', padding: '5, 5', width: '50%', textAlign: 'justify', fontSize: 10 }}>{item.Concepto}</Text>
                        <Text style={{ margin: '1,5', padding: '5, 5', width: '50%', textAlign: 'justify', fontSize: 10 }}>{item.Valor}</Text>


                    </View>

                </>
            ))}

        </View>

    );

    const PdfOnp = () => (
        <Document >
            <Page size="LETTER" >
                <Image src={process.env.PUBLIC_URL + '/static/imagen/logoPortal.png'} style={{ width: '250px', height: '80px', margin: '10, 135' }} />

                <Text style={{ textAlign: 'right', fontSize: '12', margin: '5,15' }} >Folio: {Folio} </Text>
                <Text style={{ textAlign: 'right', fontSize: '12', margin: '5,15' }} > {fecha} </Text>

                <View>
                    {tableInfoConsulta}
                </View>

                <View className={classes.verificacion} >
                    {table}
                </View>

                <View>
                    {tableRelacionRut}
                </View>

                <View style={{ flexDirection: 'row', fontSize: 9, maxWidth: '16%', justifyContent: 'space-between' }}>
                    {tableVerificacion}
                </View>

                <View>
                    {tableMorosidades}
                </View>
                {/*<Image src="images/footer.png" style={{width: '100%', position: 'absolute', bottom: 0, left: 0, right: 0 }}/>*/}
            </Page>
        </Document>
    )


    return useMemo(
        () => (
            <div>


                <PDFDownloadLink document={<PdfOnp />} fileName={`INFORME-ONP-${Folio}-${uuid(Folio)}.pdf`} target="_black">
                    {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR</h2>)}
                </PDFDownloadLink>
            </div>
        ), [])
};
export default Informe;
